import { Image } from "@heroui/react";
import ReadyToJoin from "~/components/landingPage/ReadyToJoin";
import TopImageTitleAndShortDescription from "~/components/topImageTitleAndShortDescription";

export default function pageTerms() {
	return (
		<div className=" grid  bg-white">
			<TopImageTitleAndShortDescription
				title="About Us"
				shortDescription="A national platform for registering, monitoring, and verifying GHG Emission Reduction (ER) projects."
				image="./about-us.jpeg"
				bg_color="#00000099"
			/>
			<div
				className="container mx-auto max-w-7xl space-y-5 p-5 py-5 md:py-16"
				id="how-it-words"
			>
				<div>
					<div className="grid grid-cols-1 md:grid-cols-2 gap-2 space-x-0 md:space-x-10">
						<div className="space-x-2 md:space-y-4">
							<div>
								<p className="flex justify-center md:justify-end text-center md:text-end title">
									Ensuring Transparency and Integrity in Cambodia’s Greenhouse
									Gas Emission Reductions
								</p>
							</div>
							<div>
								<p className="flex justify-center md:justify-end text-center md:text-end shortDescription">
									The Cambodia Carbon Registry serves as a vital platform for
									registering, tracking, and verifying greenhouse gas (GHG)
									emission reduction projects across Cambodia. This system
									supports the nation’s efforts to meet its climate commitments
									under both national and international frameworks, ensuring
									that emission reduction activities are conducted with
									transparency, accountability, and credibility.
								</p>
							</div>
						</div>
						<div className=" h-[300px] sm:h-[350px] md:h-[430px] relative">
							<Image
								radius="none"
								src="/green-house.png"
								classNames={{
									wrapper: "w-full h-full",
									img: "object-cover w-full h-full",
								}}
							/>
						</div>
					</div>
				</div>
			</div>

			<div>
				<TopImageTitleAndShortDescription
					title="A National Effort Towards Climate Commitments"
					shortDescription="As Cambodia continues to strengthen its climate action, this registry serves as a vital tool for overseeing GHG reduction and removal (GHG ER) projects across key sectors such as forestry, agriculture, energy, and waste management. By establishing a clear framework for project registration and verification, the platform ensures that all activities meaningfully contribute to Cambodia’s Nationally Determined Contributions (NDCs) while aligning with global climate initiatives like the Paris Agreement, REDD+, and other international carbon mechanisms."
					image="./section2-about-us.jpeg"
					bg_color="#00000066"
					isTop={false}
				/>
			</div>
			<div className="container mx-auto max-w-7xl space-y-5 p-5 py-5 md:py-16">
				<div>
					<div className="h-full w-full flex justify-center items-center">
						<div className="grid grid-cols-1 gap-4 w-full">
							<div className="flex justify-center">
								<p className={"title text-center"}>Governance & Oversight</p>
							</div>
							<div>
								<p className={"shortDescription"}>
									The Cambodia National Carbon Registry is governed under the
									Royal Government of Cambodia, ensuring compliance with both
									national policies and international standards. This governance
									structure is supported through collaboration with government
									ministries, development agencies, and technical partners,
									providing essential support for project proponents to meet
									regulatory requirements. Through close coordination with the
									Ministry of Environment and relevant stakeholders, the
									registry ensures that Greenhouse Gas Emissions Reduction (GHG
									ER) projects effectively contribute to Cambodia’s
									sustainability goals while upholding principles of
									environmental integrity.
								</p>
							</div>
							<div className="flex gap-8 sm:gap-12 mt-10 justify-center items-center">
								<span>
									<Image
										src="/rgc-logo-sm.png"
										alt="RGC Logo"
										className="max-h-[80px] sm:max-h-[130px]"
									/>
								</span>
								<span>
									<Image
										src="/moe-logo-sm.png"
										alt="MOE Logo"
										className="max-h-[80px] sm:max-h-[130px]"
									/>
								</span>
								<span>
									<Image
										radius="none"
										src="/undp-logo-sm.png"
										alt="UNDP Logo"
										className="max-h-[80px] sm:max-h-[130px]"
									/>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="bg-[#F4F4F5] py-5 md:py-16">
				<div className="container mx-auto max-w-7xl space-y-5 p-5">
					<div>
						<div className="grid grid-cols-1 md:grid-cols-2 gap-2 space-x-0 md:space-x-10">
							<div className="space-x-2 md:space-y-4">
								<div>
									<p className="flex justify-center md:justify-end text-center md:text-end title">
										Strengthening Cambodia’s Role in Global Climate Action
									</p>
								</div>
								<div>
									<p className="flex justify-center md:justify-end text-center md:text-end shortDescription">
										The Cambodia National Carbon Registry System is not just a
										database—it is an essential tool that enables Cambodia to
										take a leadership role in sustainable development and
										climate action. By fostering strong public-private
										partnerships and aligning with internationally recognized
										climate frameworks, the system enhances Cambodia’s ability
										to attract support and investment for high-quality emission
										reduction projects that deliver tangible results.
									</p>
								</div>
							</div>
							<div className=" h-[300px] sm:h-[350px] md:h-[430px] relative border-[5px] border-[#0C8442]">
								<Image
									radius="none"
									src="/climate-change.png"
									classNames={{
										wrapper: "w-full h-full",
										img: "object-cover w-full h-full",
									}}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div>
				<TopImageTitleAndShortDescription
					title="Our Commitment to Sustainability"
					shortDescription="By ensuring rigorous project oversight and verification, the Cambodia National Carbon Registry System helps build a more sustainable and resilient future. We call on all stakeholders—including government agencies, private sector entities, and non-governmental organizations—to collaborate in this effort to combat climate change and preserve Cambodia’s natural heritage while supporting sustainable development nationwide. Together, we can pave the way for a greener and more sustainable future in Cambodia."
					image="./section5-about-us.jpeg"
					bg_color="#00000066"
					isTop={false}
				/>
			</div>
			<ReadyToJoin />
		</div>
	);
}
